<div class="pagers">

  <sc-master-detail [selection]="[selectedPager]" [data]="pagers" (selectionChanged)="onSelectionChanged($event);"
    [newStyle]="true" (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">

    <sc-padding>
      <mat-tab-group>
        <mat-tab [label]="'base-data' | translate: ['tmc.admin.pager.base-data', translationService.language]">

          <sc-scroll-pane>
            <form #pagerForm="ngForm" class="form no-field-space">
              <sc-padding>
                <sc-flex [vertical]="true" [stretchContent]="true" *ngIf="workingCopyDetails != null"
                  class="no-field-space">
                  <mat-form-field appearance="fill">
                    <mat-label>{{'number' | translate: ['tmc.admin.pager.number.label', translationService.language]}}</mat-label>
                    <input [(ngModel)]="workingCopyDetails.nbr" #ctrlNumber="ngModel" name="nbr" matInput
                      [required]="true" [maxlength]="255" />
                  </mat-form-field>
                  <sc-content-spacer [vertical]="true"></sc-content-spacer>
                  <mat-form-field appearance="fill">
                    <mat-label>{{'serial number' | translate: ['tmc.admin.pager.serialnumber.label', translationService.language]}}</mat-label>
                    <input [(ngModel)]="workingCopyDetails.serialNbr" name="serialNbr" matInput
                      [required]="false" [maxlength]="255" />
                  </mat-form-field>
                  <sc-content-spacer [vertical]="true"></sc-content-spacer>
                  <mat-form-field appearance="fill">
                    <mat-label>{{'hint' | translate: ['tmc.admin.pager.hint.label', translationService.language]}}</mat-label>
                    <textarea [(ngModel)]="workingCopyDetails.hint" name="hint" matInput #ctrlHint="ngModel"
                      [required]="false"></textarea>
                  </mat-form-field>
                  <sc-content-spacer [vertical]="true"></sc-content-spacer>
                  <mat-checkbox [(ngModel)]="workingCopyDetails.available" name="available">
                    {{'available' | translate: ['tmc.admin.pager.available.label', translationService.language]}}
                  </mat-checkbox>
                </sc-flex>
              </sc-padding>
            </form>
          </sc-scroll-pane>
        </mat-tab>

        <mat-tab [label]="'report' | translate: ['tmc.admin.pager.report', translationService.language]">
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          <app-equipment-log [equipmentIdentifier]="equipmentIdentifier"></app-equipment-log>
        </mat-tab>


        <ng-template masterDetailToolbar>
          <div class="spacer grow"></div>
          <button mat-stroked-button class="config-changed-button" (click)="cancel()"
            [disabled]="!cancelEnabled">{{'cancel'
            | translate: ['tmc.admin.pager.action.cancel',
            translationService.language]}}</button>
          <sc-content-spacer></sc-content-spacer>
          <button mat-flat-button class="config-changed-button" (click)="save()" [disabled]="!saveEnabled">{{'save'
            | translate: ['tmc.admin.pager.action.save', translationService.language]}}</button>
        </ng-template>

      </mat-tab-group>

    </sc-padding>

  </sc-master-detail>

</div>